export const upgradeModal = () => {
	const upgradeBtn = document.getElementById('upgrade-btn');
	const upgradeModal = document.getElementById('upgrade-modal');

	upgradeBtn.addEventListener('click', function() {
		upgradeModal.classList.add('hidden');
	});
}
